import platform from 'platform'

export const isMac = platform.os?.family === 'OS X'
export const isWin = platform.os?.family?.toLowerCase().indexOf('window') !== -1

export const isChrome = () => platform.name === 'Chrome' || platform.name === 'Electron'
export const isSafari = () => platform.name === 'Safari'
export const isEdge = () => platform.name === 'Edge'
export const isFirefox = () => platform.name === 'Firefox'

export const isRunningInDesktop = !!window.Bridge

export const oldDesktopVersion = !window.Bridge?.getVersion && !window.Bridge?.version
export const desktopVersion = window.Bridge?.version
export const getDesktopVersion = async () => {
  // This is here for legacy sake, newest version of app has getVersion
  if (window.Bridge?.version) {
    return window.Bridge?.version
  } else if (window.Bridge?.getVersion) {
    return window.Bridge.getVersion()
  }
  return undefined
}
export const isRunningInBrowser = !isRunningInDesktop
